(function (window, $j) {

    function onDocReady() {
        var innerNavHeight = $j(".navigation-overlay .navigation-list").outerHeight();

        // $j(".wysiwyg-container").css({
        //     'min-height': innerNavHeight + "px"
        // });
        // $j(".std-inner-container").css({
        //     'min-height': innerNavHeight + "px"
        // });
    }

    $j(onDocReady);

    return {};

})(window,$j);
